import React from 'react';
import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import * as R from 'ramda';
import {DeleteEtablissementsByPartnerId} from '../../../../actions/backoffice/partners';
import { useDispatch } from 'react-redux';
import $ from 'jquery';

export const DeletePartnerEstablishment = ({isLoading, selectedEtablissement}) => {
	const dispatch = useDispatch();
	if(R.isNil(selectedEtablissement)){
		return '';
	}
	
	return (
		<div className="modal fade px-0" id="DeletePartnerEstablishment" aria-labelledby="DeletePartnerEstablishmentLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h5 className="sr-only visually-hidden">Supprimer établissements</h5>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">Supprimer le établissement</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body scroll-default py-0">
						<div className="h2 lh-copy">Supprimer le <span className="font-weight-bold">{selectedEtablissement.name}</span>?</div>
						<div className="o-80 mt-2">Ce établissement est sur le point d'être supprimé. Veuillez confirmer cette action.</div>
						<div className="fs-3 o-80 text-danger"><b className="font-weight-black">AVERTISSEMENT</b>: cette action est irréversible.</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annuler</button>
						{
							isLoading.includes(Loadings.DELETING_ETABLISSEMENT) ?
								<button className={"btn btn-danger loading-btn show"}>Oui, supprimer le établissement<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
								:
								<button className={"btn btn-danger"}
									onClick={(e) => {
										e.preventDefault();
										dispatch(DeleteEtablissementsByPartnerId(selectedEtablissement.id, selectedEtablissement.partnerId)).then(() => {
											$('.modal').modal("hide");
										})

									}}>
									Oui, supprimer le établissement
								</button>

						}

					</div>
				</div>
			</div>
		</div>
	);
}